/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */

import { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import clsx from "clsx";
import __ from "lodash";
import { Dropdown } from "bootstrap/dist/js/bootstrap.min.js";

import PublicVariables from "../../constants/PublicVariables";
import { Localize } from "./Localize";
import { changeLanguage } from "../../actions/languageAction";
import useMenuKeyboardNav from "../../hooks/useMenuKeyboardNav";

const Languages = ({isAuthorised, selectedlanguage, ...props}) => {
    const [localisedValues, setLocalisedValues] = useState({});
    const { triggerRef, menuRef } = useMenuKeyboardNav({ listbox: true });

    useEffect(() => {
        //Use timeout so that UI render first and then set event on it
        setTimeout(() => {
            const profileLanguageDropdownElement = document.getElementsByClassName('profile-language-dropdown-toggle');
            Array.from(profileLanguageDropdownElement).forEach(function (element) {
                element.addEventListener('click', (event) => {
                    event.stopPropagation();
                });
            });
        }, 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Language is both a .dropdown-item in the profile menu AND its own
    // Bootstrap dropdown-toggle. Bootstrap 5's keydown handler (delegated at
    // document with useCapture=true) would open the language sub-menu on
    // ArrowUp/Down. Beat it with a window-capture listener (window fires before
    // document in the capture cascade) and move focus manually to the next
    // profile-menu item.
    useEffect(() => {
        if (!isAuthorised) return undefined;
        const handler = (e) => {
            if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
            const langToggle = e.target.closest?.('.profile-language-dropdown-toggle');
            if (!langToggle) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            const profileMenu = langToggle.closest('.dropdown-menu');
            if (!profileMenu) return;
            const items = Array.from(profileMenu.querySelectorAll('.dropdown-item'))
                .filter((item) => item.closest('.dropdown-menu') === profileMenu);
            const currentIndex = items.indexOf(langToggle);
            if (currentIndex === -1) return;
            const nextIndex = e.key === 'ArrowDown'
                ? (currentIndex + 1) % items.length
                : (currentIndex - 1 + items.length) % items.length;
            items[nextIndex]?.focus();
        };
        window.addEventListener('keydown', handler, true);
        return () => window.removeEventListener('keydown', handler, true);
    }, [isAuthorised]);

    useEffect(() => {
        const curLang = props.language.selectedlanguage;
        setLocalisedValues(Localize[curLang.id]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.language.selectedlanguage]);

    const languageChangeHandler = (langId, event) => {
        props.changeLanguage(langId);
        const toggle = event.currentTarget.closest('.dropdown')?.querySelector('[data-bs-toggle="dropdown"]');
        if (toggle?.getAttribute('aria-expanded') === 'true') Dropdown.getOrCreateInstance(toggle).hide();
    }

    return (
        <>
            {Object.keys(localisedValues).length > 0 &&
                <div className={clsx("language-selection", isAuthorised ? "header-language-selection" : "login-language-selection")} data-testid={clsx(isAuthorised ? 'authorisedLanguageSection' : 'unauthorisedLanguageSection')}>
                    <div className="dropdown">

                        {/* role="menuitem" removed and aria-haspopup switched to "listbox" (axe on
                            2026-09-03): the outer profile popup no longer has role="menu" (see
                            Header.js), so menuitem would be an orphaned role. The language popup
                            itself is a single-select picker, so listbox+option is the correct
                            pattern (matches the SessionUsers / Assignee batch-2 refactor). */}
                        <button className={clsx("btn btn-secondary dropdown-toggle triangle-none for-selected-language", isAuthorised && "profile-language-dropdown-toggle dropdown-item")}
                            type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-haspopup="listbox" aria-expanded="false"
                            ref={triggerRef}>
                            {!isAuthorised &&
                                <div className="selected-flag">
                                    <span className={clsx("selected-flag-span", selectedlanguage.class)} data-testid={selectedlanguage.class}></span>
                                </div>
                            }
                            {isAuthorised &&
                                <span className="dropdown-item-icon icon-global"></span>
                            }
                            <div className="language-name">
                                {localisedValues['settings_language']}
                            </div>
                            {isAuthorised &&
                                <div className="selected-flag">
                                    <span className={clsx("selected-flag-span", selectedlanguage.class)}></span>
                                </div>
                            }
                        </button>
                        {PublicVariables.localiseLanguage.length > 1 &&
                            // role="menu" removed (axe aria-required-children on 2026-09-03):
                            // restructured as listbox with role="option" items matching the
                            // SessionUsers/Assignee batch-2 pattern.
                            <div className="dropdown-menu right" aria-labelledby="dropdownMenuButton1" ref={menuRef}>
                                <div className="dropdown-menu-in available-language-list custom-scroll-div-thin">
                                    <ul role="listbox" aria-labelledby="dropdownMenuButton1">
                                        {
                                            __.sortBy(PublicVariables.localiseLanguage, lang => lang.name).map((lang) => {
                                                const isSelected = lang.id === props.language.selectedlanguage.id;
                                                return (
                                                    <li key={lang.id} role="none">
                                                        <button
                                                            type="button"
                                                            className={clsx("btn-unstyled dropdown-item", isSelected && "active")}
                                                            onClick={(event) => languageChangeHandler(lang.id, event)}
                                                            role="option"
                                                            aria-selected={isSelected}
                                                            tabIndex={-1}
                                                        >
                                                            <div className="available-language-box">
                                                                <div className={clsx("flag-icon", lang.class)} aria-hidden="true"></div>
                                                                <div className="language-name">
                                                                    <div className="country-language" lang={lang.id.replace('_', '-')}>{lang.name}</div>
                                                                    <div className="country-name">{lang.state}</div>
                                                                    {isSelected && <span className="visually-hidden">, {localisedValues['selected']}</span>}
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </>
    );
}

Languages.propTypes = {
    isAuthorised: PropTypes.bool,
    selectedlanguage: PropTypes.object,
    language: PropTypes.object,
    changeLanguage: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        language: state.language
    }
}

export default connect(mapStateToProps, {
    changeLanguage
})(Languages);